import { Grid, Typography } from "@material-ui/core";
import signedInImage from "../../images/signedIn.svg";
import { I18n } from "react-redux-i18n";
import { useTheme } from "@material-ui/styles";
import { useMount } from "react-use";
import { AUTHENTICATOR_SIGNUP } from "./constants";

const SigninWelcome = ({ setInitialValue, initialValue, setAuthScreen }) => {
  const theme = useTheme();

  useMount(() => {
    setInitialValue({
      ...initialValue,
      email: "",
      password: "",
      confirmPassword: "",
      agreeTerms: false,
    });

    setAuthScreen(AUTHENTICATOR_SIGNUP);
  });

  return (
    <Grid container spacing={1}>
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src={signedInImage}
          alt="welcome avatar"
          style={{ width: "117px", height: "127px" }}
        />
      </Grid>

      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h4"
          color="primary"
          style={{
            fontFamily: "'Paytone One', sans- serif",
          }}
        >
          {I18n.t("authenticator.welcomeBack")}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography style={{ color: theme.palette.auth.readonly }}>
          {I18n.t("authenticator.welcomeBackText")}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default SigninWelcome;
